// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubaccountsLinks_SyncPaymentLinkResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for POST /payments/links/sync_payment_link/{id}
 *
 * Returns a sync summary covering all charges associated with a payment link,
 * including provider-normalized event details. The nested charges/errors
 * shapes are provider-defined and owned downstream.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type SubaccountsLinks_SyncPaymentLinkResponseDados = unknown[];

export type SubaccountsLinks_SyncPaymentLinkResponse = ApiResponse<SubaccountsLinks_SyncPaymentLinkResponseDados>;

registerResponseContract('SubaccountsLinks_SyncPaymentLinkResponse', {})
